import React from 'react';

const Disclaimer = () => {
  return (
    <div className="bg-white min-h-screen font-sans text-[#7a7a7a]">
      
      {/* Header / Breadcrumb Section with #ffdfef color */}
      <div className="relative h-44 bg-[#ffdfef] flex flex-col items-center justify-center">
        <h1 className="text-2xl md:text-3xl font-bold text-black uppercase tracking-[0.2em]">
          Disclaimer
        </h1>
        <div className="text-[12px] mt-3 text-gray-600 uppercase tracking-widest">
          Home <span className="mx-2 text-gray-400">/</span> Disclaimer
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-16 md:py-24">
        <div className="space-y-12">
          
          {/* Section 1: General Disclaimer */}
          <section className="space-y-4">
            <h2 className="text-black font-bold text-lg uppercase tracking-tight border-b border-gray-100 pb-2">
              1. General Information
            </h2>
            <p className="text-[14.5px] leading-[1.8] text-justify">
              The information provided by <strong>Simple Kindness</strong> on our platform is for general informational purposes only. All information on the site is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.
            </p>
          </section>

          {/* Section 2: Professional Disclaimer (Medical/Mental Health focus) */}
          <section className="space-y-4">
            <h2 className="text-black font-bold text-lg uppercase tracking-tight border-b border-gray-100 pb-2">
              2. Professional Disclaimer
            </h2>
            <p className="text-[14.5px] leading-[1.8] text-justify">
              The site cannot and does not contain medical or mental health advice. The information is provided for general informational and educational purposes only and is not a substitute for professional advice. Accordingly, before taking any actions based upon such information, we encourage you to consult with the appropriate professionals. The use or reliance of any information contained on this site is solely at your own risk.
            </p>
          </section>

          {/* Section 3: External Links Disclaimer */}
          <section className="space-y-4">
            <h2 className="text-black font-bold text-lg uppercase tracking-tight border-b border-gray-100 pb-2">
              3. External Links Disclaimer
            </h2>
            <p className="text-[14.5px] leading-[1.8] text-justify">
              The site may contain links to other websites or content belonging to or originating from third parties. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us. We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or reliability of any information offered by third-party websites.
            </p>
          </section>

          {/* Important Notice Box */}
          <div className="mt-16 p-8 bg-gray-50 border border-gray-100 rounded-sm">
            <h3 className="text-black font-bold uppercase text-xs mb-3 tracking-widest">Legal Notice</h3>
            <p className="text-[13px] leading-relaxed italic">
              Simple Kindness reserves the right to make additions, deletions, or modification to the contents on the Service at any time without prior notice.
            </p>
          </div>
        </div>

        {/* Footer info inside page */}
        <div className="mt-20 pt-8 border-t border-gray-100 text-[12px] text-gray-400 text-center">
          © 2026 simple kindness | Advocacy and Awareness
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;